import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { ModalController, Events } from 'ionic-angular';
import PuntoRitiro from '../../definitions/punto-ritiro.class';

@Injectable()
export class GeoPuntiRitiroProvider {

	constructor(public modalCtrl: ModalController, public storage: Storage, public events: Events) {}

	showInfoPuntoRitiro(pr): Promise<any> { // pr = punto ritiro
		const args = Object.assign({
			id            : Number(pr.id),
			stato         : pr.extra.stato,
			nome          : pr.title.rendered,
			localita      : pr.extra.localita,
			indirizzo     : pr.extra.indirizzo,
			tel           : pr.extra.tel,
			map           : pr.extra.map,
			web           : pr.extra.web,
			consegna      : pr.extra.consegna,
			metodi        : pr.extra.metodi,
			im_url        : '',
			galleria      : pr.galleria,
			contributo    : Number(pr.extra.contributo),
			spedizione    : pr.extra.spedizione,
			testo_sped    : pr.extra.testo_sped,
			gap           : pr.extra.gap,
			tipi_pagam    : pr.extra.tipi_pagam,
			soglia_gratis : Number(pr.extra.soglia_gratis),
			soglia_media  : Number(pr.extra.soglia_media),
			costo_sped_med: Number(pr.extra.costo_sped_med)
		}, new PuntoRitiro);

		try {
			args.im_url = pr._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url;
		} catch (e) {}

		// console.log(args);
		let modal = this.modalCtrl.create('ShopInfoModalPage', { dati: args });
		return new Promise((resolve, reject) => {
			modal.onWillDismiss(async data => {
				if (data && data.pr != null && data.pr.stato == 'disp') {
					// set punto di ritiro
					await this.storage.set('id_punto_ritiro_scelto', data.pr.id);
					await this.storage.set('punto_ritiro_scelto', data.pr);
				}
			});
			modal.onDidDismiss(data => resolve(data.pr))
			modal.present();
		});
	}

}



// WEBPACK FOOTER //
// ./src/providers/geo-punti-ritiro/geo-punti-ritiro.ts